var rtl_rtlignore_default = {
  "rtl": "W1Bpo",
  "ltr": "kU1AA"
};
export {
  rtl_rtlignore_default as default
};
//# sourceMappingURL=rtl.rtlignore-scss.js.map
